import { render, staticRenderFns } from "./CheckDepositSuccess.vue?vue&type=template&id=f9993d40&"
import script from "./CheckDepositSuccess.vue?vue&type=script&lang=js&"
export * from "./CheckDepositSuccess.vue?vue&type=script&lang=js&"
import style0 from "./CheckDepositSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports